const KpiStrip = ({ children, columns = "auto" }) => {
  const colClass =
    columns === 6
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6"
      : columns === 5
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5"
      : columns === 4
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
      : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5";
  return (
    <div className={`grid gap-4 ${colClass}`}>{children}</div>
  );
};

export default KpiStrip;
